import { fetchWithAuth } from "../utils/auth";

export const sendTestEmail = async (showId: number, showTemplateType: string): Promise<any> => {
    try {
      const body: string = JSON.stringify({showId: showId, showTemplateType: showTemplateType});
      const res = await fetchWithAuth(`/api/backend/notification/test-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      });
      if (res.status >= 400 && res.status < 600) {
        const resText = await res.json();
        return resText
      }
      return res;
    } catch (error) {
      return { error };
    }
  };
  